import $ from 'jquery'
import prop from 'vue-strict-prop'
import { component } from 'vue-tsx-support'

export default component({
	name: 'HeaderBar',
	props: {
		title: prop(String).optional,
	},
	methods: {
		openSidebar(): void {
			$('.sidebar').sidebar('show')
		},
	},
	render() {
		return (
			<div class="ui fixed inverted main menu" id="header-bar">
				<div class="ui container">
					<div class="icon link item" onClick={() => this.openSidebar()}>
						<i class="large content icon"></i>
					</div>
					<div class="item">
						{this.title}
					</div>
					{this.$slots.default}
				</div>
			</div>
		)
	},
})
